import { payloadAction } from './common'

export const SHOW_FORM_ERROR = 'SHOW_FORM_ERROR'
export const showFormError = payloadAction(SHOW_FORM_ERROR)
